import React from 'react'
import { Spinner } from '../Spinner'
import { hasWindow } from '@ztechapps/common.utils'

export type ClientOnlyProps = {
  component: any
} & Record<any, any>

export const ClientOnly = (props: ClientOnlyProps) => {
  const component = React.useRef<any>(null)

  const withWindows = hasWindow()

  React.useEffect(() => {
    if (!withWindows) return

    //setComponent(() => React.lazy(props.component))
    component.current = React.lazy(props.component)
  }, [withWindows])

  return component.current ? <component.current {...props} /> : <Spinner />
}
